import React from 'react';
import { rugbyLeagueStatKeyToNameMap } from '@ligr/api-v2';
import { Match } from '../../../../../api-types';

import { Select } from '../../../../Select';
import { Checkbox } from '../../../../Checkbox/Checkbox';
import { TriggerProps } from '@ligr/themes/lib/rugbyLeague/themes/default/Templates/Scoreboard/types';

import './style.scss';

interface ScoreboardCustomProps {
  value?: Partial<TriggerProps>;
  onChange: (update: Partial<TriggerProps>) => any;
  match: Match;
  disabled?: boolean;
}

// FULLY CONTROLLED ONLY
export const Scoreboard: React.FunctionComponent<ScoreboardCustomProps> = ({
  disabled,
  onChange,
  value = {},
  match
}) => {
  return (
    <div className="scoreboard">
      <div className="scoreboard__preset">
        <Checkbox
          disabled={!value.teamId || !value.primaryStatName}
          checked={value.preset === 'teamStats'}
          onChange={() => {
            return onChange({
              ...value,
              preset: value.preset !== 'teamStats' ? 'teamStats' : 'default'
            });
          }}
          label="Show Team Stat/s"
        />{' '}
        <div> Include </div>
      </div>
      <div className="scoreboard__team">
        <Select
          disabled={disabled}
          value={value.teamId}
          onChange={event => {
            // @ts-ignore
            return onChange({ ...value, teamId: parseInt(event.target.value) });
          }}
          label="Team"
          options={[
            {
              value: null,
              label: 'Select Team'
            },
            {
              value: match.homeTeam.id,
              label: match.homeTeam.gfxName || match.homeTeam.name
            },
            {
              value: match.awayTeam.id,
              label: match.awayTeam.gfxName || match.awayTeam.name
            }
          ]}
        />
      </div>
      <div className="scoreboard__stat">
        <Select
          disabled={disabled}
          value={value.primaryStatName}
          onChange={event => {
            // @ts-ignore
            return onChange({ ...value, primaryStatName: event.target.value });
          }}
          label="First Stat"
          // @ts-ignore
          options={([
            {
              value: null,
              label: 'Select First Stat'
            }
          ] as { value: null | string; label: string }[]).concat(
            Object.entries(rugbyLeagueStatKeyToNameMap).map(([value, label]) => ({
              value,
              label
            }))
          )}
        />
        {/*<Select
        disabled={disabled}
        value={value.secondaryTeamStat}
        onChange={event => {
          // @ts-ignore
          return onChange({ ...value, secondaryTeamStat: event.target.value });
        }}
        label="Second Stat"
        // @ts-ignore
        options={[{
          value: '',
          label: 'None'
          // @ts-ignore
        }].concat(Object.entries(statKeyToNameMap).map(([value, label]) => ({
          value,
          label
        })))}
      />*/}
      </div>
    </div>
  );
};
